import React, { useState, useEffect } from 'react';
import { Spinner, Intent, PanelStack } from "@blueprintjs/core";

import Spacer from 'components/spacer';
import Loader from 'components/loader';

import Folder from 'assets/img/folder.svg';

import './index.css';

const FolderRow = ({ selected, onOpen, onSelect, title }) => {
    const [hover, setHover] = useState(false);
    const [loading, setLoading] = useState(false);

    let style = 'panel-stack__row clickable';

    if (hover || selected) {
        style += ' panel-stack__row--hover'
    }

    const hoverStart = () => setHover(true);
    const hoverEnd = () => setHover(false);

    return (
        <div
            className={style}
            onDoubleClick={() =>{
                setLoading(true);

                if (onOpen) onOpen();
            }}
            onClick={onSelect}
            onMouseEnter={hoverStart}
            onMouseLeave={hoverEnd}
        >
            <div className='panel-stack__row__info'>
                <div>
                    <img className='panel-stack__row__icon' src={Folder} />
                </div>

                <Spacer size='m' horizontal/>

                <p>{title}</p>
            </div>
            {loading && <Spinner size={25} intent={Intent.NONE} />}
        </div>
    );
}
 
const FolderPanel = ({ readyCb, fetcher, folders = [], onChangePanel, openPanel, stackTitles,  ...props }) => {
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (readyCb) {
            readyCb(selected)
        }
    }, [selected])

    return (
        <div>
            {folders.map(folder => {
                const path = `/${stackTitles.join('/')}/${folder.title || folder.name}/`;

                return (
                    <FolderRow
                        key={folder.id}
                        onSelect={() => {
                            setSelected({
                                id: folder.id,
                                path,
                                name: folder.title || folder.name
                            })
                        }}
                        selected={selected && selected.id === folder.id}
                        onOpen={() => {
                            fetcher(folder.id, stackTitles)
                            .then(_folders => {
                                setSelected(null);

                                openPanel({
                                    component: FolderPanel, // <- class or stateless function type
                                    props: {
                                        readyCb,
                                        fetcher,
                                        folders: _folders,
                                        stackTitles: [folder.title || folder.name, ...stackTitles],
                                        ...props
                                    },
                                    title: folder.title || folder.name,        // <- appears in header and back button
                                })
                            })
                            .catch(() => {})
                        }}
                        title={folder.title || folder.name}
                    />
                );
            })}
        </div>
    );
};


export default ({ title, type, fetcher, readyCb, ...props }) => {
    const [loading, setLoading] = useState(true);
    const [folders, setFolders] = useState([]);

    useEffect(() => {
        fetcher('root')
        .then(_folders => {
            setFolders(_folders);
            setLoading(false);
        })
    }, []);

    return (
        <>
            {
                loading ?
                <Loader />
                :
                <PanelStack
                    className='panel-stack-container'
                    initialPanel={
                        {
                            component: FolderPanel,
                            props: {
                                readyCb,
                                fetcher,
                                folders,
                                stackTitles: [],
                                ...props
                            },
                            title
                        }
                    }
                />
            }
        </>
    )
}